import api from '@services/api';
import {
  RuleClassificationRequest,
  RuleClassificationResponse,
} from '../models/RuleClassification';

/**
 * <p>
 * API endpoints that cover all classification rule CRUD
 */
export const RuleClassificationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    allRuleClassification: builder.query<Array<RuleClassificationResponse>, void>({
      query: () => ({
        url: encodeURI(`/school/rule-classification/findAll`),
      }),
      providesTags: ['AllRuleClassification'],
    }),
    CreateClassify: builder.mutation<RuleClassificationResponse, RuleClassificationRequest>({
      query: (body: RuleClassificationRequest) => ({
        url: `/school/rule-classification/create`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['AllRuleClassification'],
    }),
    DeleteClassify: builder.mutation<void, number>({
      query: (id: number) => ({
        url: `/school/rule-classification/delete?id=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['AllRuleClassification'],
    }),
  }),
});

export const {
  useAllRuleClassificationQuery,
  useCreateClassifyMutation,
  useDeleteClassifyMutation,
} = RuleClassificationApi;
